import React from 'react'
import { Redirect } from 'react-router-dom'

import {
  AdminLoginPage,

  LoginPage,
  RegisterPage,
  VerifyEmail,
  ResendEmail,
  ForgotPassword,
  ResetPassword,

  CompanyDashboard,
  AdminManagementPage,
  PendingPage,
  AwaitingConfirmationPage,
  AcceptedPage,
  ArchivePage,
  MaterialsAndMachinesPage,
  BulkOrderPage,
  BulkOrderDetailsPage,
  NestingPage,
  ExternalCustomerRelations,
  InternalCustomerRelations,
  CompanySettingsPage,

  DraftOrderPage,
  DxfTipsPage,
  StepTipsPage,

  CustomerDashboard,
  CustomerPendingPage,
  CustomerAcceptedPage,
  CustomerCompletedPage,
  RegularCustomerSettingsPage,
  CorporateCustomerSettingsPage,

  AdminDashboard,
  AllProducers,
  AllCustomers,
  AllCorporateCustomers,
  AdminLogPage,

  OrderDetailsPage,

  TestPage,
} from '../containers'

import { withRedirect } from './helpers'
import {storage} from "../utils";

const withMiddleware = ({ component: Component, roleNames, permission }) => () => {
  const user = store.getState().auth.user

  if (!user) {
    storage.storeAuthData(null)
    return <Redirect to={{ pathname: '/login' }} />
  }

  const roleName = user.role

  if (!roleNames.includes(roleName)) {
    return <Redirect to={{ pathname: '/' }} />
  }

  if(roleName === "producerSubAdmin" && permission) {
    if(!user.permissions?.includes(permission)) {
      return <Redirect to={{ pathname: '/' }} />
    }
  }

  return <Component />
}

let store

const routes = {
  all: [
    {
      path: '/',
      exact: true,
      component: () => {
        const user = store.getState().auth.user;
        const authTime = storage.retrieveTimePassed()

        if(user !== null && authTime !== null && authTime >= 216000) {
          storage.storeAuthData(null)
          return <Redirect to={{ pathname: '/login' }} />
        }

        const role = user.role

        switch (role) {
          case 'headAdmin':
            return <AdminDashboard />

          case 'producerAdmin':
          case 'producerSubAdmin':
            return <CompanyDashboard />

          case 'regularCustomer':
          case 'corporateCustomer':
            return <CustomerDashboard />

          default:
            return null
        }
      },
    },
    {
      path: '/loginAdmin',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: AdminLoginPage,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/login',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: LoginPage,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/register',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: RegisterPage,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/confirm-email',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: VerifyEmail,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/resend-email',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: ResendEmail,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/forgot-password',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: ForgotPassword,
        elseRedirectTo: '/',
      }),
    },
    {
      path: '/recover-password',
      exact: true,
      isPublic: true,
      component: withRedirect({
        ifTrue: () => store.getState().auth.user === null,
        thenRenderComponent: ResetPassword,
        elseRedirectTo: '/',
      }),
    },

    {
      path: '/employeeManagement',
      exact: true,
      component: withMiddleware({
        component: AdminManagementPage,
        roleNames: ['producerAdmin'],
      }),
    },
    {
      path: '/pending',
      exact: true,
      component: withMiddleware({
        component: PendingPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/awaiting',
      exact: true,
      component: withMiddleware({
        component: AwaitingConfirmationPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/accepted',
      exact: true,
      component: withMiddleware({
        component: AcceptedPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/archive',
      exact: true,
      component: withMiddleware({
        component: ArchivePage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/materials',
      exact: true,
      component: withMiddleware({
        component: MaterialsAndMachinesPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'materials'
      }),
    },
    {
      path: '/calculation',
      exact: true,
      component: withMiddleware({
        component: BulkOrderPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'bulk'
      }),
    },
    {
      path: '/calculation/:orderId/details',
      exact: true,
      component: withMiddleware({
        component: BulkOrderDetailsPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'bulk'
      }),
    },
    {
      path: '/nesting',
      exact: true,
      component: withMiddleware({
        component: NestingPage,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'nesting'
      }),
    },
    {
      path: '/external-customer-relations',
      exact: true,
      component: withMiddleware({
        component: ExternalCustomerRelations,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'customers'
      }),
    },
    {
      path: '/internal-customer-relations',
      exact: true,
      component: withMiddleware({
        component: InternalCustomerRelations,
        roleNames: ['producerAdmin', 'producerSubAdmin'],
        permission: 'customers'
      }),
    },
    {
      path: '/company-settings',
      exact: true,
      component: withMiddleware({
        component: CompanySettingsPage,
        roleNames: ['producerAdmin', 'producerSubAdmin']
      }),
    },

    {
      path: '/draft',
      exact: true,
      component: withMiddleware({
        component: DraftOrderPage,
        roleNames: ['regularCustomer', 'corporateCustomer'],
      }),
    },
    {
      path: '/pending-order',
      exact: true,
      component: withMiddleware({
        component: OrderDetailsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/awaiting-order',
      exact: true,
      component: withMiddleware({
        component: OrderDetailsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/accepted-order',
      exact: true,
      component: withMiddleware({
        component: OrderDetailsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/completed-order',
      exact: true,
      component: withMiddleware({
        component: OrderDetailsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
        permission: 'orders'
      }),
    },
    {
      path: '/dxf-tips',
      exact: true,
      component: withMiddleware({
        component:  DxfTipsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
      }),
    },
    {
      path: '/step-tips',
      exact: true,
      component: withMiddleware({
        component:  StepTipsPage,
        roleNames: ['regularCustomer', 'corporateCustomer', 'producerAdmin', 'producerSubAdmin'],
      }),
    },

    {
      path: '/pending-orders',
      exact: true,
      component: withMiddleware({
        component: CustomerPendingPage,
        roleNames: ['regularCustomer', 'corporateCustomer'],
      }),
    },
    {
      path: '/accepted-orders',
      exact: true,
      component: withMiddleware({
        component: CustomerAcceptedPage,
        roleNames: ['regularCustomer', 'corporateCustomer'],
      }),
    },
    {
      path: '/completed-orders',
      exact: true,
      component: withMiddleware({
        component:  CustomerCompletedPage,
        roleNames: ['regularCustomer', 'corporateCustomer'],
      }),
    },

    {
      path: '/customer-settings',
      exact: true,
      component: withMiddleware({
        component: RegularCustomerSettingsPage,
        roleNames: ['regularCustomer'],
      }),
    },
    {
      path: '/corporate-settings',
      exact: true,
      component: withMiddleware({
        component: CorporateCustomerSettingsPage,
        roleNames: ['corporateCustomer'],
      }),
    },

    {
      path: '/producers',
      exact: true,
      component: withMiddleware({
        component: AllProducers,
        roleNames: ['headAdmin'],
      }),
    },
    {
      path: '/customers',
      exact: true,
      component: withMiddleware({
        component: AllCustomers,
        roleNames: ['headAdmin'],
      }),
    },
    {
      path: '/corporate',
      exact: true,
      component: withMiddleware({
        component: AllCorporateCustomers,
        roleNames: ['headAdmin'],
      }),
    },
    {
      path: '/logs',
      exact: true,
      component: withMiddleware({
        component: AdminLogPage,
        roleNames: ['headAdmin'],
      }),
    },
    {
      path: '/test',
      exact: true,
      component: withMiddleware({
        component: TestPage,
        roleNames: ['headAdmin'],
      }),
    },
    {
      path: '/*',
      isPublic: true,
      component: () => <Redirect to={{ pathname: '/' }} />,
    },
  ],
  setStore: newStore => {
    store = newStore
  },
}

export { routes }
